import gql from 'graphql-tag';
import CommonObservations from './observations';

export default gql`
  fragment CommonPatientInfo on PatientInfo {
    _id
    firstName
    lastName
    name
    birthDate
    sex
    hasRequestedEcg
    observations {
      ...CommonObservations
    }
    psychInfo {
      hasSignedTelemedConsent
      hasSignedMedRecordsReleaseConsent
      consentsMedRecordsRelease
      otherInfo
      pcp
    }
  }
  ${CommonObservations}
`;
